import * as React from 'react'
import { IconStyled } from './styled'
import { IIconProps } from './types'

const Icon: React.FC<IIconProps> = ({ src, padding, ...props }) => {
  return <IconStyled src={src} padding={padding} {...props} />
}

export default Icon
